import {
  AccountsRepository,
  RegisterAccountInput,
} from '@lib/api/repository/accounts/accounts.repository';
import { AccountsUseCase } from '@lib/interfaces/usecase/accounts.use-case';
import { Account, AdminAccount } from '@lib/types';
import { AdminPageFilters } from '@lib/types/admin-page';

class AccountsService implements AccountsUseCase {
  listAdminPage(filters: AdminPageFilters, signal?: AbortSignal) {
    return this.repository.listAdminPage(filters, signal);
  }

  constructor(private readonly repository: AccountsRepository) {}

  setCPF(cpf: string): Promise<Account> {
    return this.repository.setCPF(cpf);
  }

  register(data: RegisterAccountInput): Promise<Account> {
    return this.repository.register(data);
  }

  list(signal?: AbortSignal): Promise<AdminAccount[]> {
    return this.repository.list(signal);
  }

  create(data: Account): Promise<Account> {
    return this.repository.create(data);
  }

  update(data: Account): Promise<Account> {
    return this.repository.update(data);
  }

  updateProfilePhoto(photo: File): Promise<Account> {
    return this.repository.updateProfilePhoto(photo);
  }

  updatePassword(currentPassword: string, newPassword: string): Promise<void> {
    return this.repository.updatePassword(currentPassword, newPassword);
  }

  askVerificationCode(): Promise<void> {
    return this.repository.askVerificationCode();
  }

  verify(code: string): Promise<Account> {
    return this.repository.verify(code);
  }

  exportData(signal?: AbortSignal) {
    return this.repository.exportData(signal);
  }

  deleteAccount(password: string) {
    return this.repository.deleteAccount(password);
  }

  setActive(id: string, active: boolean) {
    return this.repository.setActive(id, active);
  }
}

export default AccountsService;
